

import React, {Component} from 'react';
import { Redirect  } from "react-router-dom";


class ModalHotelFilter extends Component {

    state = {
        redirect : null,
        chk7 : false,

        
        checkedEilat :false,
        checkedDeadSea: false,
        checkedKineret : false, 
        checkedMerchaz : false, 
        checkedJerusalem : false,
        checkedDarom:false,
        hasParking:false,
        hasSpa:false,
        hasPool: false
    }

    componentDidMount = () => {
        console.log('ModalHotelFilter componentDidMount props', this.props);
        
    }

    setModalHotelDisplayClosed = () => {
        //this.props.setModalHotelDisplayClosed();
        this.setState({ redirect: "/hotels/1" }); 
    }
    

    setModalFilterClosed = () =>  {
        this.props.setModalFilterClosed();
    }
    
    
    searchFilterHotels = () => {     
        
        let places = { 
            checkedEilat : this.state.checkedEilat,
            checkedDeadSea :this.state.checkedDeadSea,
            checkedKineret :this.state.checkedKineret,
            checkedMerchaz :this.state.checkedMerchaz,
            checkedJerusalem :this.state.checkedJerusalem,
            checkedDarom :this.state.checkedDarom
            }; 

            let mainFacilities = { 
                hasParking : this.state.hasParking,
                hasSpa :this.state.hasSpa,
                hasPool:this.state.hasPool
                }; 

        let data = {};
        data.search_param_places =  places;
        data.search_param_mainFacilities =  mainFacilities;
        this.props.searchFilterHotels(data);
     }



    toggleEilat = e => {
        let t = this.state.checkedEilat;
        this.setState( {checkedEilat:!t} );
    };

    toggleDeadSea = e => {
        let t = this.state.checkedDeadSea;
        this.setState( {checkedDeadSea:!t} );
    };

    toggleKineret = e => {
        let t = this.state.checkedKineret;
        this.setState( {checkedKineret:!t} );
    };

    toggleMerchaz = e => {
        let t = this.state.checkedMerchaz;
        this.setState( {checkedMerchaz:!t} );
    };
    
    
    toggleJerusalem = e => {
        let t = this.state.checkedJerusalem;
        this.setState( {checkedJerusalem:!t} );
    };

    toggleDarom = e => {
        let t = this.state.checkedDarom;
        this.setState( {checkedDarom:!t} );
    };
    

    toggleParking = e => {
        let t = this.state.hasParking;
        this.setState( {hasParking:!t} );
    };
    
    toggleSpa = e => {
        let t = this.state.hasSpa;
        this.setState( {hasSpa:!t} );
    };

    togglePool = e => {
        let t = this.state.hasPool;
        this.setState( {hasPool:!t} );
    };
    
  render() { 

    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 

    const { hotel } =  this.props; 


    return (

        

             <React.Fragment>
                <div className="modal_filter_bg" ></div>
                    <div className="hotels_list_filter_box">
                        <div className="close_arrow pointer zindex1000" 
                            onClick={ () => this.setModalFilterClosed() }></div>

                        <div className="filter_container">
                            <div className="filter_container_inner">
                                <div className="hotel_details_rigth_title_padding">
                                    <span className="filter_container_title1">סינונים </span>
                                    <img className="margingBottom" src={"/images/site/filter.png"} />
                                </div>
                                <div className="filter_container_title2">
                                מיקום   
                                </div>

                                <div className="checkForm marginTop14">
                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk1"
                                            checked={this.state.checkedEilat}
                                            onChange={this.toggleEilat} 
                                        ></input>
                                        <label htmlFor="chk1">אילת</label>
                                    </div>
                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk2"
                                            checked={this.state.checkedDeadSea}
                                            onChange={this.toggleDeadSea} 
                                        ></input>
                                        <label htmlFor="chk2">ים המלח</label>
                                    </div>
                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk3"
                                            checked={this.state.checkedKineret}
                                            onChange={this.toggleKineret} 
                                        ></input>
                                        <label htmlFor="chk3">חיפה, טבריה והצפון </label>
                                    </div>

                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk4"
                                            checked={this.state.checkedMerchaz}
                                            onChange={this.toggleMerchaz} 
                                        ></input>
                                        <label htmlFor="chk4">תל אביב, השרון והסביבה </label>
                                    </div>

                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk5"
                                            checked={this.state.checkedJerusalem}
                                            onChange={this.toggleJerusalem} 
                                        ></input>
                                        <label htmlFor="chk5">ירושלים והסביבה</label>
                                    </div>

                                    <div className="check-form-group">
                                        <input 
                                            type="checkbox" 
                                            id="chk6"
                                            checked={this.state.checkedDarom}
                                            onChange={this.toggleDarom} 
                                        ></input>
                                        <label htmlFor="chk6">אשדוד, אשקלון והדרום</label>
                                    </div>
                                </div>


                                
                                <div className="hotel_details_paddingTop20"></div>
                                <div className="hp_search_pad1_line"></div>
                                <div className="filter_container_title2 marginTop14">
                                מתקנים ושירותים   
                                </div>

                                <div className="checkForm marginTop14">
                                    <div className="check-form-group">
                                        <input type="checkbox"
                                            id="chk7"
                                            checked={this.state.hasParking}
                                            onChange={this.toggleParking} 
                                         ></input>
                                        <label htmlFor="chk7">חניה</label>
                                    </div>
                                    <div className="check-form-group">
                                        <input type="checkbox" 
                                            id="chk8"
                                            checked={this.state.hasSpa}
                                            onChange={this.toggleSpa} >

                                            </input>
                                        <label htmlFor="chk8">ספא</label>
                                    </div>
                                    <div className="check-form-group">
                                        <input type="checkbox" 
                                        id="chk9"
                                        checked={this.state.hasPool}
                                        onChange={this.togglePool} >
                                        
                                        </input>
                                        <label htmlFor="chk9">בריכה</label>
                                    </div>

                                </div>

                                <div className="hotel_details_paddingTop20"></div>
                                <div className="hp_search_pad1_line"></div>
                                <div className="cntered-flex ">
                                    <div className="hp_search_main_filter_button marginTop14" onClick={() => this.searchFilterHotels()}>
                                        <span className="filter_btn_main_button_title">
                                            הצג תוצאות
                                        </span> 
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                               
                </React.Fragment>      
        )
    }
            
    

  

} //component

export default ModalHotelFilter;
